import { render } from "./MessageBar.vue?vue&type=template&id=58638a9c&scoped=true&ts=true"
import script from "./MessageBar.vue?vue&type=script&lang=ts"
export * from "./MessageBar.vue?vue&type=script&lang=ts"

import "./MessageBar.vue?vue&type=style&index=0&id=58638a9c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58638a9c"]])

export default __exports__